import { useEffect, useState } from 'react';
import { Target } from '../components/Widget/types';
import { IStrategyAssetTarget } from '../types/model';
import {
  computePercentage,
  getValuePercentageFromBase,
  isValidTarget,
} from '../helpers/functions';

const newTarget: Target = {
  alert: true,
  endDate: undefined,
  id: '',
  stopLoss: {
    AMOUNT: undefined,
    AMOUNT_IN_REPORTING_CURRENCY: undefined,
    PERCENTAGE: undefined,
  },
  stopProfit: {
    AMOUNT: undefined,
    AMOUNT_IN_REPORTING_CURRENCY: undefined,
    PERCENTAGE: undefined,
  },
};

export const useTargets = ({
  alert,
  entryPrice,
  inspirationSource,
  items,
  entryExchangePrice,
}: {
  alert: boolean;
  entryPrice: number;
  inspirationSource: string;
  items: Partial<IStrategyAssetTarget>[];
  entryExchangePrice: number;
}) => {
  const [inspiration, setInspiration] = useState<string>(inspirationSource);
  const [isAlertTargetActive, setAlertTarget] = useState<boolean>(alert);
  const [isTargetsUpdated, setIsTargetsUpdated] = useState(false);
  const [targets, setTargets] = useState<Target[]>(
    items.length > 0
      ? items.map(
          ({ stopLoss, stopProfit, id, endDate }) =>
            ({
              alert,
              endDate: endDate !== undefined ? new Date(endDate) : undefined,
              id,
              stopLoss: {
                AMOUNT: stopLoss,
                AMOUNT_IN_REPORTING_CURRENCY: stopLoss
                  ? stopLoss * entryExchangePrice
                  : undefined,
                PERCENTAGE: Math.abs(
                  computePercentage(entryPrice, stopLoss ?? 0, 100)
                ),
              },
              stopProfit: {
                AMOUNT: stopProfit,
                AMOUNT_IN_REPORTING_CURRENCY: stopProfit
                  ? stopProfit * entryExchangePrice
                  : undefined,
                PERCENTAGE: computePercentage(entryPrice, stopProfit ?? 0, 100),
              },
            } as Target)
        )
      : [{ ...newTarget, alert: isAlertTargetActive }]
  );

  useEffect(() => {
    // setTargets(
    //   targets.map((target) => ({
    //     ...target,
    //     stopLoss: {
    //       AMOUNT: target.stopLoss.PERCENTAGE
    //         ? entryPrice -
    //           getValuePercentageFromBase(entryPrice, target.stopLoss.PERCENTAGE)
    //         : target.stopLoss.PERCENTAGE,
    //       AMOUNT_IN_REPORTING_CURRENCY:
    //         target.stopLoss.AMOUNT_IN_REPORTING_CURRENCY,
    //       PERCENTAGE: target.stopLoss.PERCENTAGE,
    //     },
    //     stopProfit: {
    //       AMOUNT: target.stopProfit.PERCENTAGE
    //         ? entryPrice +
    //           getValuePercentageFromBase(
    //             entryPrice,
    //             target.stopProfit.PERCENTAGE
    //           )
    //         : target.stopProfit.PERCENTAGE,
    //       AMOUNT_IN_REPORTING_CURRENCY:
    //         target.stopProfit.AMOUNT_IN_REPORTING_CURRENCY,
    //       PERCENTAGE: target.stopProfit.PERCENTAGE,
    //     },
    //   }))
    // );
  }, [entryPrice]);

  const addTarget = () =>
    setTargets([...targets, { ...newTarget, alert: isAlertTargetActive }]);

  const handleInspiration = (newInspiration: string) => {
    setInspiration(newInspiration);
  };

  const removeTarget = (i: number) => {
    !isTargetsUpdated && isValidTarget(targets[i]) && setIsTargetsUpdated(true);
    targets.length === 1 && setIsTargetsUpdated(false);

    setTargets(
      targets.length > 1
        ? [...targets.slice(0, i), ...targets.slice(i + 1)]
        : [
            {
              alert: isAlertTargetActive,
              endDate: undefined,
              id: '',
              stopLoss: {
                AMOUNT: undefined,
                PERCENTAGE: undefined,
              },
              stopProfit: {
                AMOUNT: undefined,
                PERCENTAGE: undefined,
              },
            },
          ]
    );
  };

  const toggleAlert = () => {
    setAlertTarget(!isAlertTargetActive);
  };

  const updateTargets = (i: number, target: Target) => {
    !isTargetsUpdated && isValidTarget(target) && setIsTargetsUpdated(true);

    setTargets([...targets.slice(0, i), target, ...targets.slice(i + 1)]);
  };

  const isDisabledSaveAction =
    !isTargetsUpdated &&
    alert === isAlertTargetActive &&
    inspirationSource === inspiration;

  const canAddNewTarget = isValidTarget(targets[targets.length - 1]);

  return {
    canAddNewTarget,
    inspiration,
    isAlertTargetActive,
    isDisabledSaveAction,
    targets,
    addTarget,
    removeTarget,
    handleInspiration,
    toggleAlert,
    updateTargets,
  };
};
